import { CaretDownFilled, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select, Space } from "antd";
import "moment/locale/zh-cn";
import React, { ReactElement, useContext } from "react";
import { WarningRuleParams } from "../../services/warningRule";
import { ThemeContext } from "../../theme/theme";

export const WarningRuleQuerys = (props: {
  onValueChange: (queries: WarningRuleParams) => void;
}): ReactElement => {

  const [form] = Form.useForm();

  const theme = useContext(ThemeContext);

  return (
    <Form
      form={form}
      onFinish={(values) => props.onValueChange(values)}
    >
      <Row
        style={{ marginBottom: 10, width: "100%" }}
        align="middle"
        justify="space-between"
      >
        <Space>
          <Form.Item name="nameOrId" noStyle>
            <Input
              autoComplete="off"
              placeholder="主项编码名称"
              style={{ width: 200 }}
              onChange={form.submit}
              prefix={<SearchOutlined />}
              allowClear
            />
          </Form.Item>
          <Form.Item name="cautionType" noStyle>
            <Select
              showSearch
              suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
              style={{ width: "200px" }}
              allowClear
              onChange={form.submit}
              placeholder="规则分类"
            >
              <Select.Option value={0}>规则分类-基础类</Select.Option>
              <Select.Option value={1}>规则分类-个性类</Select.Option>
            </Select>
          </Form.Item>
        </Space>
        <Col>
          <Button
            type="primary"
            onClick={() => props.onValueChange(form.getFieldsValue())}
          >
            查询
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
